<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="radio-inline mb-2">
          <div class="custom-label" style="display:inline-block;margin-right:30px;">{{ $static('reviews.status-header',
            'Статус') }}</div>
          <div class="default-radio">
            <input id="review-status2" type="radio" name="review-status" value="unmoderated"
              @change="handleCheckedReviewsStatus($event)" :checked="checkedReviewsStatus === 'unmoderated'">
            <label for="review-status2">{{ $static('reviews.on-moderation', 'На модерації') }}</label>
          </div>
          <div class="default-radio">
            <input id="review-status1" type="radio" name="review-status" value="moderated"
              @change="handleCheckedReviewsStatus($event)" :checked="checkedReviewsStatus === 'moderated'">
            <label for="review-status1">{{ $static('reviews.viewed', 'Розглянуті') }}</label>
          </div>
        </div>

        <div class="table-wrapper">
          <div class="table-responsive">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th>{{ $static('reviews-table.number', 'Номер') }}</th>
                  <th>{{ $static('reviews-table.raiting', 'Рейтинг') }}</th>
                  <th>{{ $static('reviews-table.comment', 'Комментар') }}</th>
                  <th class="text-center">{{ $static('reviews-table.visibility', 'Видимість') }}</th>
                  <th>{{ $static('reviews-table.time', 'Час') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr style="cursor: pointer" v-for="review in reviews" @click="openReviewEditor(review)">
                  <td>
                    #{{ review.id }}
                  </td>
                  <td>
                    {{ review?.body?.reviewRaiting ?? '-' }}
                  </td>
                  <td><span>{{ review?.body?.comment ?? '-' }}</span></td>
                  <td>
                    <div class="toggler r" @click.stop="editReviewVisibility(review)">
                      <input type="checkbox" class="toggle-check" v-model="review.active">
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                  </td>
                  <td>{{ getReviewDate(review) }}</td>
                  <td>
                    <Popper arrow content='Редагувати' hover placement="left" style="white-space: nowrap">
                      <button class="btn-icon btn-rounded btn-icon-transparent order_edit">
                        <span class="icon icon-edit"></span>
                      </button>
                    </Popper>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="pagination-panel table-pagination" v-if="pages.length > 1">
          <nav>
            <router-link
              :to="{ name: 'Reviews', params: { status: this.checkedReviewsStatus, page: Math.max(pageIndex - 1, 1) } }"
              class="previous extreme" :class="{ 'disabled': pageIndex < 2 }">
              <span class="icons icon-left"></span>
            </router-link>
            <ul class="pagination pagination-list">
              <li v-for="(page, index) in pages" :key="index" :class="{ 'active': pageIndex === page }">
                <router-link :to="{ name: 'Reviews', params: { status: this.checkedReviewsStatus, page: page } }">
                  {{ page }}
                </router-link>
              </li>
            </ul>
            <router-link
              :to="{ name: 'Reviews', params: { status: this.checkedReviewsStatus, page: Math.min(pageIndex + 1, pageAmount) } }"
              class="end extreme" :class="{ 'disabled': pageIndex > pageAmount - 1 }">
              <span class="icons icon-right"></span>
            </router-link>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <Teleport to="body">
    <div class="overlay-editor item-editor">
      <div class="overlay-editor-wrapper">
        <ReviewEditor v-if="selectedReviewForEdit" :selectedReviewForEdit="selectedReviewForEdit"
          :checkedReviewsStatus="checkedReviewsStatus" @closeReviewEditor="closeReviewEditor"
          @deleteReview="deleteReview" @reviewChanged="handleReviewChange" />
      </div>
    </div>
  </Teleport>
</template>

<script>
import ReviewEditor from '@/components/ReviewEditor.vue'

const pageSlotsAmount = 5;

export default {
  name: 'Reviews',
  components: { ReviewEditor },
  props: ['status', 'page'],

  data() {
    return {
      reviews: [],
      checkedReviewsStatus: undefined,
      selectedReviewForEdit: undefined,
      total: 0,
      filter: {
        page: 1,
        perPage: 10,
        status: ''
      },
      savingReview: false
    }
  },

  computed: {
    pages() {
      if (this.pageAmount < pageSlotsAmount) return [...Array(this.pageAmount).keys()].map(x => x + 1);

      let min = Math.max(this.pageIndex - (pageSlotsAmount - 1) / 2, 1);
      if (this.pageIndex + 1 >= this.pageAmount) {
        min = this.pageAmount - 4;
      }
      let result = [...Array(pageSlotsAmount).keys()].map(x => x + min);
      result[0] = 1;
      result[pageSlotsAmount - 1] = this.pageAmount;

      return result;
    },

    pageAmount() {
      return Math.ceil(this.total / this.filter.perPage);
    },

    pageIndex() {
      return (this.page && Number.isInteger(+this.page)) ? +this.page : 1;
    },
    currentLang() {
      const currentLang = localStorage.getItem('$lang');
      console.log(currentLang)
      if (currentLang && currentLang !== "" && currentLang !== "ua") {
        return currentLang
      }
      return "uk"
    }
  },

  watch: {
    checkedReviewsStatus(newStatus, oldStatus) {
      if (newStatus === 'unmoderated') {
        this.filter.status = '';
      }
      if (newStatus === 'moderated') {
        this.filter.status = 'confirm';
      }

      if (oldStatus === undefined) {

        this.filter.page = this.$route.params?.page === '' ? 1 : this.$route.params?.page;

        this.$router.push({ name: 'Reviews', params: { status: this.checkedReviewsStatus, page: this.$route.params?.page ?? 1 } });
      } else {
        this.filter.page = 1;

        this.$router.push({ name: 'Reviews', params: { status: this.checkedReviewsStatus, page: 1 } });
      }

      this.getReviews();
    },

    page(val) {
      this.filter.page = val;
      this.getReviews();
    }
  },

  methods: {
    openReviewEditor(rev) {
      this.selectedReviewForEdit = rev;

      window.$('body').addClass('is-hidden');
      window.$('.back-blur').addClass('active');
      window.$('.overlay-editor.item-editor').addClass('active');
    },

    closeReviewEditor() {
      this.selectedReviewForEdit = undefined;

      window.$('body').removeClass('is-hidden');
      window.$('.back-blur').removeClass('active');
      window.$('.overlay-editor.item-editor').removeClass('active');
    },

    handleCheckedReviewsStatus(event) {
      this.checkedReviewsStatus = event.target.value;
    },

    getReviewDate(review) {
      const dateFromBackend = new Date(review.body.reviewTime * 1000).toLocaleDateString(this.currentLang);
      return dateFromBackend.length !== 10 ? '-' : dateFromBackend;
    },

    async editReviewVisibility(rev) {
      rev.active = !rev.active;
      await this.handleReviewChange(rev);
    },

    async handleReviewChange(review) {
      if (this.savingReview) return;
      this.savingReview = true;

      const changedReviewIndex = this.reviews.findIndex((rev) => rev.id === review.id);
      const changedReview = { ...this.reviews[changedReviewIndex], ...review };

      try {
        let response;

        if (this.checkedReviewsStatus === 'unmoderated') {
          response = await fetch('/api/review/approve', {
            body: JSON.stringify(changedReview),
            method: 'POST'
          });
        } else if (this.checkedReviewsStatus === 'moderated') {
          response = await fetch('/api/review/update', {
            body: JSON.stringify(changedReview),
            method: 'POST'
          });
        }

        if (!response.ok) {
          throw new Error('Не удалось сохранить изменения отзыва');
        }

        this.$notify({
          title: this.$static('notify.reviews-title', 'Відгуки'),
          text: this.$static('reviews.success-save', 'Відгук збережено'),
          duration: 1000
        });

        this.selectedReviewForEdit = undefined;
        await this.getReviews(); // Обновление списка после успешного изменения
        this.closeReviewEditor();

      } catch (error) {
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('reviews.save-error', 'Сталася помилка при збереженні відгуку'),
          type: 'error',
          duration: 2000
        });
        console.error(error);
      } finally {
        this.savingReview = false;
      }
    },

    async deleteReview() {
      if (this.checkedReviewsStatus === 'moderated') return;

      try {
        const response = await fetch('/api/review/approve', {
          body: JSON.stringify({ id: this.selectedReviewForEdit.id }),
          method: 'POST'
        });

        if (!response.ok) {
          throw new Error('Не удалось удалить отзыв');
        }

        this.$notify({
          title: this.$static('notify.reviews-title', 'Відгуки'),
          text: this.$static('reviews.success-remove', 'Відгук видалено успішно'),
          duration: 1000
        });

        this.selectedReviewForEdit = undefined;
        await this.getReviews();
        this.closeReviewEditor();

      } catch (error) {
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('reviews-remove-error', 'Сталася помилка при видаленні відгуку'),
          type: 'error',
          duration: 2000
        });
        console.error(error);
      }
    },

    async getReviews() {
      try {
        const response = await fetch('/api/review', {
          body: JSON.stringify({ filter: this.filter }),
          method: 'POST'
        });

        if (!response.ok) {
          throw new Error('Не удалось получить отзывы');
        }

        const data = await response.json();

        this.reviews = data.result;
        this.total = data.total;
        this.filter.page = data.page;

      } catch (error) {
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('reviews-update-error', 'Сталася помилка при оновленні данних по відгукам'),
          type: 'error',
          duration: 2000
        });
        console.error(error);
      }
    }
  },

  async mounted() {
    this.checkedReviewsStatus = this.$route.params?.status || 'unmoderated';

    // Нужен для сброса selectedReviewForEdit. Без него просто убирается видимость редактора отзыва, с сохранением а не сбросом данных
    const backBlur = document.querySelector('.back-blur');
    backBlur.addEventListener('click', this.closeReviewEditor
    );
  },

  beforeUnmount() {
    const backBlur = document.querySelector('.back-blur');
    backBlur.removeEventListener('click', this.closeReviewEditor);
  }
}
</script>

<style lang="scss" scoped></style>
